import { useProduct } from "./useProduct";
import { useSelectedProductAttribute } from "./useSelectedProductAttribute";

const createAlternativeProductCode = (
	{ code, aspectRatio, predefinedName }: eXpress.core.Product,
	selectedAtributeCode: eXpress.ProductAttributeCode | undefined,
) => {
	return eXpress.AlternativeProductCode.create(
		code,
		selectedAtributeCode,
		aspectRatio,
		predefinedName,
	);
};

export const useSelectedAlternativeProduct = () => {
	const product = useProduct();
	const currentProductAttribute = useSelectedProductAttribute();

	return product ? createAlternativeProductCode(product, currentProductAttribute) : undefined;
};
